import { Action, createReducer, on } from '@ngrx/store';
import { IRendicontazioniState } from './rendicontazione';
import { ResponseRendicontazioni } from '../../interfaces/response-rendicontazione';
import { RESET_RENDICONTAZIONE_STORE, RETRIEVE_RENDICONTAZIONI_SUCCESS } from './rendicontazione.actions';

/* INITIAL STATE */
const initialState: IRendicontazioniState = {
  rendicontazioni: null,
};

const handleRendicontazioni = (
  state: IRendicontazioniState,
  { rendicontazioni }: { rendicontazioni: ResponseRendicontazioni | null }
): IRendicontazioniState => {
  return {
    ...state,
    rendicontazioni: rendicontazioni,
  };
};

const handleResetRendicontazioneStore = (): IRendicontazioniState => {
  return {
    rendicontazioni: null,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_RENDICONTAZIONI_SUCCESS, handleRendicontazioni),
  on(RESET_RENDICONTAZIONE_STORE, handleResetRendicontazioneStore)
);

export const rendicontazioniReducer = (
  state: IRendicontazioniState | undefined,
  action: Action
): IRendicontazioniState => reducer(state, action);
